/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_27f51a97"]'><cube-button outline>细框按钮</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_27f51a97"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_27f51a97"}
  /** script content **/
  require("./btn-outline.mpx.js?isComponent&outputPath=components%2Fbtn-outline27f51a97%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-outline.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-outline27f51a97%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_27f51a97"],
    ctorType: "component",
    outputPath: "components/btn-outline27f51a97/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>